import { Shield, Lock, Smartphone, QrCode } from "lucide-react";

function AuthTechnology() {
  const features = [
    {
      icon: Shield,
      title: "Multi-Layer Authentication",
      desc: "Combine physical and digital security measures for unbreakable product verification",
    },
    {
      icon: Lock,
      title: "Blockchain Security",
      desc: "Immutable records stored on distributed ledger technology",
    },
    {
      icon: Smartphone,
      title: "Mobile Verification",
      desc: "Instant authentication through smartphone scanning",
    },
    {
      icon: QrCode,
      title: "Smart Tags",
      desc: "Tamper-evident QR codes for physical security",
    },
  ];

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-7xl mx-auto">

        {/* Heading */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-black mb-6">
            Advanced Authentication Technology
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Multi-layer security architecture that adapts to your product and industry requirements
          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((item, index) => {
            const Icon = item.icon;
            return (
              <div
                key={index}
                className="p-6 bg-gradient-to-br from-gray-50 to-white rounded-2xl border border-gray-200 hover:border-blue-600 hover:shadow-xl transition-all duration-300 group"
              >
                {/* Icon Box */}
                <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 group-hover:bg-blue-600 transition-colors">
                  <Icon className="w-6 h-6 text-blue-600 group-hover:text-white transition-colors" />
                </div>

                {/* Title */}
                <h3 className="text-lg font-bold text-black mb-2">
                  {item.title}
                </h3>

                {/* Description */}
                <p className="text-gray-600 text-sm">
                  {item.desc}
                </p>
              </div>
            );
          })}
        </div>

      </div>
    </section>
  );
}

export default AuthTechnology;